import { reactive } from 'vue';

/**
 * 目前僅用於：
 * 1. 按下 Default Layout 的 logo 時，Home Page 的操作彈窗(#operate-modal)需顯示。
 * 2. Home Page 的操作彈窗內按下 LOGO ON/OFF 時，Default Layout 的 logo 設置 opacity 顯藏。
 * 若未來使用 Pinia 時，再重構 Default Layout 的 onClickLogo 與 Home Page 的 logoOpacity。
 */
const eventBus = reactive({});

export default eventBus;
